import React from 'react';

const About = () => {
    return (
        <section id="about">
            <h2>About Me</h2>
            <p>
                I am a data analyst with a passion for turning data into actionable insights. 
                My goal is to leverage data to drive decision-making and improve business outcomes. 
                I have experience in data visualization, statistical analysis, and data cleaning, 
                and I am proficient in tools such as Python, SQL, and Tableau.
            </p>
            <p>
                I am constantly seeking to expand my knowledge and skills in the field of data analytics 
                and am excited about the opportunities to work on challenging projects that make a difference.
            </p>
        </section>
    );
};

export default About;